exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".createRecipePage.container-fluid {\n  margin: 0px;\n  padding-top: 50px;\n  width: 100%; }\n\n.createRecipePage-header {\n  margin-bottom: 200px; }\n\n.edit-recipe-form {\n  margin: 0px;\n  width: 100%; }\n", ""]);

// exports
